import React from 'react';
import { Redirect, useParams } from 'wouter';
import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { BoardData } from '../../../api/ApiTypes';
import { useLoaderWithRefresh } from '../../../platform/Hook';
import { useResolve } from '../../Container';
import { EditorOptions } from '../../canvas/EditorOptions';
import { PointerHandler } from '../../canvas/PointerHandler';
import { TemplateHeaderBlock } from '../../canvas/TemplateHeaderBlock';
import { KioskEditorScope } from '../../canvas/kiosk/KioskEditorScope';
import { CaptureWheel, ToolLayer } from '../../canvas/tooling/ToolLayer';
import { CanvasView } from '../../canvas/ui/CanvasView';
import { HtmlRenderer } from '../../canvas/visualization/HtmlRenderer';
import { WidgetLayer } from '../../canvas/workspace/widgets/WidgetLayer';
import { Crumbs } from '../../common/Crumbs';
import { Page } from '../../common/Page';

const PageImpl = React.memo(() => {
    const { entityId } = useParams<{ entityId: string }>();
    const options = EditorOptions.fromWindow(false);

    const api = useResolve(ApiClient);
    const [loading, snapshot] = useLoaderWithRefresh(
        () => api.exec(v2.templates.snapshot2(entityId)),
        [entityId]
    );

    const board: BoardData = {
        id: entityId,
        name: 'Kiosk',
        label: 'Kiosk',
        type: 2,
        userId: 'US0000KIOSK',
        podId: '',
        password: false,
        viewers: 'workspace',
        joiners: 'workspace',
        thumbUrl: null,
        createdAt: new Date(),
        updatedAt: new Date(),
        accountId: 'AC0000KIOSK',
        workspaceId: null,
        folderId: null,
    };

    const permissions = [
        'base:read',
        'bo:read',
    ];

    if (loading) return null;

    return <KioskEditorScope {...{ board, permissions, snapshot, options }}>
        <Page canton={options.ui ? '/' : null}>
            {options.ui &&
                <Page.Header divide="hover">
                    <Crumbs>
                        <Crumbs.Title>

                        </Crumbs.Title>
                    </Crumbs>
                    <Page.HeaderPush>
                        <TemplateHeaderBlock />
                    </Page.HeaderPush>
                </Page.Header>
            }
            <Page.Content flush>
                <CanvasView>
                    <HtmlRenderer />
                    <PointerHandler />
                    <CaptureWheel>
                        <ToolLayer />
                        {options.ui && <>
                            <WidgetLayer />
                        </>}
                    </CaptureWheel>
                </CanvasView>
            </Page.Content>
        </Page>
    </KioskEditorScope>;
});

export const TemplatePreviewPage = React.memo(() => {
    const { entityId } = useParams<{ entityId: string }>();
    if (entityId.startsWith('BO')) return <Redirect to={`~/${entityId}`} />;
    return <PageImpl />;
});
